import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { noop } from 'src/components/base';

import { AppContext } from 'src/components/app-context';

import ChangelogBadge from '../../../changelog/components/badge';

import actions from '../../actions/mobile-menu';
import { trackOpeningSidebar } from '../../../sidebar/tracking';
import { VIEWS } from '../../../sidebar/components/sidebar-mobile/constants';

import * as S from './styles';

import { AppState } from '../../../../reducers';

type Props = {
  handleOnClick?: () => void;
};

export default function MobileButton({ handleOnClick = noop }: Props) {
  const { t } = useContext(AppContext);
  const { open } = useSelector(
    (state: AppState) => state.areas.navigation.mobileMenu
  );
  const dispatch = useDispatch();

  const toggleMenu = () => {
    if (open) {
      dispatch(actions.closeMenu());
    } else {
      trackOpeningSidebar(VIEWS.ROOT, 'MobileMenuButton');
      dispatch(actions.openMenu());
      handleOnClick();
    }
  };

  return (
    <S.MenuButton
      onClick={toggleMenu}
      aria-label={t('header', 'mobile-menu.title')}
      data-test="MobileMenuButton"
    >
      <ChangelogBadge />
      <S.MenuIcon size={32} />
    </S.MenuButton>
  );
}
